export default "__VITE_ASSET__65451505__"